import { type LaneState, StatusIcon } from '@viko/transcript-ui'

/**
 * State icons (docs/ux/design-language.md §7): Lucide loader-circle run · ◆ needs you ·
 * octagon-alert blocked · circle-check ok · circle-x failed · circle-dashed queued.
 */
export type GlyphKind = 'run' | 'wait' | 'blocked' | 'ok' | 'fail' | 'idle'

/** Decorative: the state is always also written out in text next to it. */
export function Glyph({ kind, size = 16 }: { kind: GlyphKind; size?: number }) {
  return <StatusIcon kind={kind} size={size} className={`lk-glyph is-${kind}`} />
}

export const LANE_GLYPH: Record<LaneState, GlyphKind> = {
  queued: 'idle',
  running: 'run',
  blocked: 'blocked',
  'needs-you': 'wait',
  verifying: 'run',
  landing: 'run',
  landed: 'ok',
  unverified: 'idle',
  hidden: 'idle',
}
